import axios from "axios";

export default function UnasShowService(unasId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/unas/" + unasId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
